import Statistic from '@/modules/statistics/view/StatisticsView.vue';

export const StatsRoutes = [
    {
        path: '/statistics/',
        component: Statistic,
    }
]